module.exports = __webpack_public_path__ + "img/or.60fdffe5.png";